/**
 * Resolve a config sound entry to a playback-ready { path, volume }.
 *
 * Config may store a path string or `{ path, volume }` with volume in 0–1.
 * Missing volume is 1 (100%). `defaultVolume` is used when the entry is a
 * string or an object that omits volume (loot containers' soundVolume).
 *
 * @param {string|{ path?: string, volume?: number }|null|undefined} entry
 * @param {{ defaultVolume?: number }} [options]
 * @returns {{ path: string, volume: number }|null}
 */
export function resolveSound(entry, options = {}) {
  const defaultVolume = clampVolume(
    typeof options.defaultVolume === 'number' ? options.defaultVolume : 1
  );

  if (typeof entry === 'string') {
    if (!entry) return null;
    return { path: entry, volume: defaultVolume };
  }

  if (entry && typeof entry === 'object') {
    const path = typeof entry.path === 'string' ? entry.path : '';
    if (!path) return null;
    const volume = typeof entry.volume === 'number'
      ? clampVolume(entry.volume)
      : defaultVolume;
    return { path, volume };
  }

  return null;
}

function clampVolume(value) {
  if (!Number.isFinite(value)) return 1;
  return Math.max(0, Math.min(1, value));
}
